/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Pricing_Pro_DescInputs */

const en_landing_pricing_pro_desc = /** @type {(inputs: Landing_Pricing_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`For growing teams`)
};

const zh_landing_pricing_pro_desc = /** @type {(inputs: Landing_Pricing_Pro_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`适合成长型团队`)
};

/**
* | output |
* | --- |
* | "For growing teams" |
*
* @param {Landing_Pricing_Pro_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_pricing_pro_desc = /** @type {((inputs?: Landing_Pricing_Pro_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Pricing_Pro_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_pricing_pro_desc(inputs)
	return zh_landing_pricing_pro_desc(inputs)
});
export { landing_pricing_pro_desc as "landing.pricing.pro_desc" }